'use strict';

(function () {
  const init = (root) => {
    const slider = root.querySelector('.benifits-bar__slider');
    if (!slider) return;
    if (typeof Swiper === 'undefined') return;

    const buildOptions = () => {
      return {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: false,
        watchOverflow: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
      };
    };

    if (slider.swiper) return;

    // eslint-disable-next-line no-new
    new Swiper(slider, buildOptions());
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('benifits-bar').forEach((el) => init(el));
  });
})();
